import chroma from 'chroma-js';
import { COLOR_MAP } from '../constants';

export function getColorVairables(color: string) {
  if (color === 'brand') {
    // The default color
    return '';
  }

  // Check if it's a predefined color first
  const predefinedColors = COLOR_MAP[color as keyof typeof COLOR_MAP];
  if (predefinedColors) {
    let variables = '';
    for (const [level, hex] of Object.entries(predefinedColors)) {
      variables += `--brand-${level}: ${hexToRgb(hex)};\n`;
    }
    return variables;
  }

  // Generate shades for arbitrary color
  try {
    const baseColor = chroma(color);
    const shades = generateColorShades(baseColor);

    let variables = '';
    for (const [level, chromaColor] of Object.entries(shades)) {
      const rgb = chromaColor.rgb();
      variables += `--brand-${level}: ${rgb.join(' ')};\n`;
    }
    return variables;
  } catch (error) {
    console.error(`Invalid color: ${color}`, error);
    return '';
  }
}

function generateColorShades(
  baseColor: chroma.Color,
): Record<string, chroma.Color> {
  const shades: Record<string, chroma.Color> = {};

  // Use the input color as shade 500 (base)
  shades['500'] = baseColor;

  // Generate lighter shades (25-400)
  const lighterShades = [
    { shade: '25', mix: 0.95 },
    { shade: '50', mix: 0.9 },
    { shade: '100', mix: 0.8 },
    { shade: '200', mix: 0.65 },
    { shade: '300', mix: 0.45 },
    { shade: '400', mix: 0.25 },
  ];

  lighterShades.forEach(({ shade, mix }) => {
    shades[shade] = chroma.mix(baseColor, '#ffffff', mix, 'rgb');
  });

  // Generate darker shades (600-950)
  const darkerShades = [
    { shade: '600', mix: 0.15 },
    { shade: '700', mix: 0.3 },
    { shade: '800', mix: 0.45 },
    { shade: '900', mix: 0.65 },
    { shade: '950', mix: 0.8 },
  ];

  darkerShades.forEach(({ shade, mix }) => {
    shades[shade] = chroma.mix(baseColor, '#000000', mix, 'rgb');
  });

  return shades;
}

function hexToRgb(hex: string): string {
  const result = /^#?(?<r>[a-f\d]{2})(?<g>[a-f\d]{2})(?<b>[a-f\d]{2})$/i.exec(
    hex,
  );
  if (!result?.[1] || !result[2] || !result[3]) {
    console.error(`Unknown hex color: ${hex}`);
    return '';
  }
  return [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16),
  ].join(' ');
}
